import React from "react";
import { Segment, Header, Icon, Label } from "semantic-ui-react";
import "./NextPayment.scss";

export function NextPayment(props) {
  const { paymentData } = props;

  if (!paymentData) {
    return null;
  }

  return (
    <Segment className="dashboard-segment warning-segment">
      <Header as="h3" dividing>
        <Icon name="bell" />
        Próximo Pago
      </Header>
      <div className="next-payment-info">
        <h4>{paymentData.conceptName}</h4>
        <p className="amount">S/. {paymentData.amount}</p>
        <p className="date">
          <Icon name="calendar" />
          Vence: {new Date(paymentData.dueDate).toLocaleDateString("es-PE")}
        </p>
        <p className="status">
          <Label color="orange" size="small">
            <Icon name="clock" /> Pendiente
          </Label>
        </p>
      </div>
    </Segment>
  );
}
